export const ProgramEnhancementCurrentProgress = {
  ProgramEnhanced: 'Program enhanced',
  InProgress: 'In progress',
  NotStarted: 'Not started'
}
